import {
  FORM_ASSEMBLY_TOGGLE_MODAL,
  GLOBAL_CHAMBER_PLAN_SCALE_IN,
  GLOBAL_CHAMBER_PLAN_SCALE_MT,
  GLOBAL_PIPE_PLAN_SCALE_IN,
  GLOBAL_PIPE_PLAN_SCALE_MT,
  GLOBAL_REFRESH_ADMIN_PROJECTS, REP_CONTACT_TOGGLE_DIALOG, SALES_CONTACT_DIALOG,
  SET_DISABLED_LAYER_DIALOG,
  SET_PROJECT_URL_INVALID, SIGN_UP_MODAL_TOGGLE, SYSTEM_NOTES_TOGGLE_DIALOG,
} from '../lib/types';

export const switchRefreshAdminProjects = ( change ) => dispatch => {
  dispatch({
    type: GLOBAL_REFRESH_ADMIN_PROJECTS,
    payload: change
  });
};


export const setPlanScaleInchesChamber = ( value ) => dispatch => {
  dispatch({
    type: GLOBAL_CHAMBER_PLAN_SCALE_IN,
    payload: value
  });
};

export const setPlanScaleInchesPipe = ( value ) => dispatch => {
  dispatch({
    type: GLOBAL_PIPE_PLAN_SCALE_IN,
    payload: value
  });
};

export const setPlanScaleMtsChamber = ( value ) => dispatch => {
  dispatch({
    type: GLOBAL_CHAMBER_PLAN_SCALE_MT,
    payload: value
  });
};

export const setPlanScaleMtsPipe = ( value ) => dispatch => {
  dispatch({
    type: GLOBAL_PIPE_PLAN_SCALE_MT,
    payload: value
  });
};

export const setProjectsUrlInvalidDialog = ( value ) => dispatch => {
  dispatch({
    type: SET_PROJECT_URL_INVALID,
    payload: value
  });
};

export const setDisableLayerLoginDialog = ( value ) => dispatch => {
  dispatch({
    type: SET_DISABLED_LAYER_DIALOG,
    payload: value
  });
};

export const toggleFormAssemblyModal =
  (toggle, formUrl, showCloseBtn) => (dispatch) => {
    dispatch({
      type: FORM_ASSEMBLY_TOGGLE_MODAL,
      payload: { toggle, formUrl, showCloseBtn },
    });
  };

export const toggleRepContactDialog = (toggle, showCloseBtn) => (dispatch) => {
  dispatch({
    type: REP_CONTACT_TOGGLE_DIALOG,
    payload: { toggle, showCloseBtn },
  });
};

export const toggleSignupModal = (toggle) => (dispatch) => {
  dispatch({
    type: SIGN_UP_MODAL_TOGGLE,
    payload: { toggle },
  });
};

export const toggleSalesContactDialog = (toggle) => (dispatch) => {
  dispatch({
    type: SALES_CONTACT_DIALOG,
    payload: toggle,
  });
};

export const toggleSystemNotesToggleDialog = (toggle) => (dispatch) => {
  dispatch({
    type: SYSTEM_NOTES_TOGGLE_DIALOG,
    payload: toggle,
  });
};



// WEBPACK FOOTER //
// ./src/actions/generic-globals.actions.js